export const hasActiveSubscription = () => {
  return (document.getElementById("has-active-subscription") as HTMLInputElement)?.value === "true" ? "yes" : "no";
};
